import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
} from '@angular/core';


@Component({
  selector: 'app-collapse-card-job',
  templateUrl: './collapse-card-job.component.html',
  styleUrls: ['./collapse-card-job.component.scss']
})
export class CollapseCardJobComponent implements OnInit {

  @Input()
  header = 'Header'

  @ViewChild('collapseCard') elementView: ElementRef;
  viewHeight: number;

  // isCollapse = false
  isCollapse = false;

  constructor() { }

  toggleCollapse() {
    this.isCollapse = !this.isCollapse
  }

  ngOnInit() {
  }


  ngAfterContentInit() {
    setTimeout(() => {
      this.viewHeight = this.elementView.nativeElement.offsetHeight;
    }, 1000);
  }

}
